import { JsonFormsLayout } from './JsonFormLayout';
import { rankWith, uiTypeIs } from '@jsonforms/core';
import type { Layout, RankedTester, RendererProps } from '@jsonforms/core';
import { withJsonFormsLayoutProps } from '@jsonforms/react';
import React from 'react';
import { RenderChildren } from 'src/components/JsonForm/RenderChildren';

export interface GridLayout extends Layout {
    type: 'GridLayout';
}

export const gridClasses =
    '@container grid grid-cols-1 @xs:grid-cols-2 @md:grid-cols-3 @3xl:grid-cols-4 @5xl:grid-cols-5 gap-x-5 gap-y-2';

export const GridLayoutTester: RankedTester = rankWith(10, uiTypeIs('GridLayout'));

export const GridLayoutStableRenderer = (props: RendererProps) => {
    const { data: _data, ...otherProps } = props;
    // We don't hand over data to the layout renderer to avoid rerendering it with every data change
    return <GridLayoutRendererMemoizedComponent {...otherProps} />;
};

const GridLayoutRendererComponent = ({ schema, uischema, enabled, visible, path }: RendererProps) => {
    const layout = uischema as GridLayout;

    return layout.elements.length > 0 ? (
        <JsonFormsLayout
            className={gridClasses}
            visible={visible}
            enabled={enabled}
            path={path}
            uischema={uischema}
            schema={schema}
        >
            <RenderChildren
                layout={layout}
                schema={schema}
                path={path}
                enabled={enabled}
                className="[&:empty]:hidden"
            />
        </JsonFormsLayout>
    ) : null;
};

const GridLayoutRendererMemoizedComponent = React.memo(GridLayoutRendererComponent);

export const GridLayoutRenderer = withJsonFormsLayoutProps(GridLayoutStableRenderer, false);
